'use client';
import React, { useEffect } from 'react';
import DoctorItem from '../doctors/doctor-item';
import { DoctorItemSkeleton } from '../doctors/sub-component';
import { useSelector } from 'react-redux';
import { RootState } from '@store/root-reducer';
import { Div, Text } from '@pezeshk-book/ui-kit';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';
import { LocaleTypes } from '@dictionaries-types';

const ExtendedDoctors = () => {
  const { usersListToShow, usersList, csr, loading } = useSelector((state: RootState) => state.users);
  const { lang } = useParams<{lang: LocaleTypes}>();
  const { users } = getDictionary(lang);
  useEffect(() => {
    if (csr) {
      const temp = document.getElementById('static-doctors');
      if (temp) {
        temp.className = 'hidden';
      }
    }
  }, [csr]);

  if (loading) {
    return (
      <>
        <DoctorItemSkeleton/>
        <DoctorItemSkeleton/>
        <DoctorItemSkeleton/>
      </>
    );
  }

  if (csr) {
    if (usersList && usersList.length && !loading) {
      return (
        <>
          {usersList.map((item: any, index: any) => (
            <DoctorItem
              hashUserId={item?.route_key_affix}
              key={index}
              isOnline={!!item?.is_online}
              typeTitle={item?.type_title}
              speciality={item?.specialty_title}
              specialityType={item?.specialty_type_title}
              photo={item?.picture_affix || 'https://pezeshkbook.appcosolution.com/image/original/users/user_data/2020/01/30/104940500/image/images.jpeg'}
              name={item?.full_name}
              slug={item?.slug}
              rate={item?.score}
              provinceTitle={item?.province_title || users.index.doctor_item.unknown}
              userServiceFee={item?.serviceFee?.data}
              userContacts={item?.contacts?.data}
              locale={lang}
              translate={users.index.doctor_item}
            />
          ))}
        </>
      );
    }
    return (
      <Div className={'w-full bg-white border border-control-100 items-center justify-center h-28 rounded-xl mb-28'}>
        <Text color={'grey.600'} typography={'xl'} type={'medium'}>
          {users.index.no_info}
        </Text>
      </Div>
    );
  }

  if (usersListToShow && usersListToShow.length && !loading) {
    return (
      <>
        {usersListToShow.map((item: any, index: any) => (
          <DoctorItem
            hashUserId={item?.route_key_affix}
            key={index}
            isOnline={!!item?.is_online}
            typeTitle={item?.type_title}
            speciality={item?.specialty_title}
            specialityType={item?.specialty_type_title}
            photo={item?.picture_affix || 'https://pezeshkbook.appcosolution.com/image/original/users/user_data/2020/01/30/104940500/image/images.jpeg'}
            name={item?.full_name}
            slug={item?.slug}
            rate={item?.score}
            provinceTitle={item?.province_title || users.index.doctor_item.unknown}
            userServiceFee={item?.serviceFee?.data}
            userContacts={item?.contacts?.data}
            locale={lang}
            translate={users.index.doctor_item}
          />
        ))}
      </>
    );
  }

  return null;
};

export default ExtendedDoctors;
